import { createMediaStyles } from 'lib/styled-helpers'
import { FC, useCallback } from 'react'
import styled from 'styled-components'
import { HorizontalMoveAnimation } from 'ui/horizontal-move-animation'
import { Icon } from 'ui/icon'
import { PopupCover } from 'ui/popup-cover'

import { ScrollableContainer } from '../scrollable-container'

export type Props = {
  width: string
  title: string
  onClose(): void
  show: boolean
}

export const PopupForm: FC<Props> = ({ children, width, title, onClose, show }) => {
  const PopupCoverComponent = useCallback(({ children }) => {
    return <PopupCover onCoverClick={() => onClose()}>{children}</PopupCover>
  }, [])

  return (
    <HorizontalMoveAnimation show={show} Wrapper={PopupCoverComponent}>
      <Container width={width}>
        <Header>
          <Title>{title}</Title>
          <CloseButton onClick={onClose}>
            <Icon name="cancel" size={1} />
          </CloseButton>
        </Header>
        <ScrollableContainer maxHeight={'100%'}>
          <Body>{children}</Body>
        </ScrollableContainer>
      </Container>
    </HorizontalMoveAnimation>
  )
}

const Container = styled.div<{ width: string }>`
  position: relative;
  height: 100%;
  width: 100%;
  max-width: ${({ width }) => width};
  background: #fff;
  overflow: auto;
`

const Header = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.8rem 2rem;
  background: ${({ theme }) => theme.palette.grey[50]};
`

const Title = styled.div`
  ${({ theme }) => theme.textStyles.h5};
  color: ${({ theme }) => theme.palette.grey[900]};
`

const Body = styled.div`
  ${createMediaStyles(() => ({
    phone: 'padding: 1.6rem 2.4rem;',
    tablet: 'padding: 3.2rem 4rem;'
  }))}
`

const CloseButton = styled.button`
  position: absolute;
  right: 2rem;
  background: rgba(0, 0, 0, 0);
  padding: 0;
  border: none;
  cursor: pointer;
`
